<template>
  <div class="page new-ticket">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'register' | lang }}</div>
    </header>
    <div>
      <div class="small-form">
        <div>
          <div class="floating-label">
            <input v-model="email" placeholder=" " type="text" :class="{ invalid: invalidEmail }" :disabled="status == 'success'" />
            <label>{{ 'Email' | lang }}</label>
          </div><span></span><span></span><span></span>
          <ul id="password-errors">
            <li class="text-red" v-if="invalidEmail"><i class="fa fa-fw fa-exclamation-triangle"></i>&nbsp;{{ 'EmailNotValid' | lang }}</li>
            <li class="text-green" v-else><i class="fa fa-fw fa-check"></i>&nbsp;{{ 'EmailValid' | lang }}</li>
          </ul>
        </div>
        <div>
          <div class="floating-label">
            <input autocomplete="new-password" v-model="password" placeholder=" " :type="showPassword ? 'text' : 'password'" class="with-icon-right" :class="{ invalid: passwordErrors.all }" :disabled="status == 'success'" />
            <i class="fa fa-fw right" :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }" @click="showPassword = !showPassword"></i>
            <label>{{ 'Password' | lang }}</label>
          </div>
          <span></span><span></span><span></span>
          <div>
            {{ 'PasswordConditions' | lang }}
            <ul id="password-errors">
              <li :class="{ 'text-green': !passwordErrors.maiuscola, 'text-red': passwordErrors.maiuscola }">
                <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.maiuscola, 'fa-exclamation-triangle': passwordErrors.maiuscola }"></i>&nbsp;{{ 'AtLeastAnUpperLetter' | lang }}
              </li>
              <li :class="{ 'text-green': !passwordErrors.minuscola, 'text-red': passwordErrors.minuscola }">
                <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.minuscola, 'fa-exclamation-triangle': passwordErrors.minuscola }"></i>&nbsp;{{ 'AtLeastALowerLetter' | lang }}
              </li>
              <li :class="{ 'text-green': !passwordErrors.cifra, 'text-red': passwordErrors.cifra }">
                <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.cifra, 'fa-exclamation-triangle': passwordErrors.cifra }"></i>&nbsp;{{ 'AtLeastADigit' | lang }}
              </li>
              <li :class="{ 'text-green': !passwordErrors.simbolo, 'text-red': passwordErrors.simbolo }">
                <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.simbolo, 'fa-exclamation-triangle': passwordErrors.simbolo }"></i>&nbsp;{{ 'AtLeastASymbol' | lang }}
              </li>
              <li :class="{ 'text-green': !passwordErrors.lunghezza, 'text-red': passwordErrors.lunghezza }">
                <i class="fa fa-fw" :class="{ 'fa-check': !passwordErrors.lunghezza, 'fa-exclamation-triangle': passwordErrors.lunghezza }"></i>&nbsp;{{ 'AtLeast8chars' | lang }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <div @click="rememberMe = !rememberMe">
        <i class="fa fa-fw" :class="{ 'fa-check-square-o': rememberMe, 'fa-square-o': !rememberMe }"></i>Ricordami
      </div> -->
      <div v-if="status">
        <div v-if="status === 'waiting'">
          <i class="fa fa-fw fa-refresh fa-spin"></i>{{ 'pleaseWait' | lang }}
        </div>
        <div v-else-if="status === 'error'" class="text-red">
          <i class="fa fa-fw fa-exclamation-triangle"></i>{{ (statusDetails || 'errorOccured') | lang }}
        </div>
        <div v-else-if="status === 'success'" class="text-green">
          <i class="fa fa-fw fa-check"></i>{{ 'RegistrationDone' | lang }}
        </div>
      </div>
    </div>
    <footer>
      <button class="full-width" @click="register" :disabled="invalidForm || isWaiting || status == 'success'">{{ 'register' | lang }}</button>
    </footer>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import UserServices from '@/mixins/services/userServices'
import SimpleDialog from '@/dialogs/SimpleDialog'
import { create } from 'vue-modal-dialogs'

const simpleDialogCreator = create(SimpleDialog)

export default {
  name: 'Registration1',
  mixins: [ page, UserServices ],
  data () {
    return {
      email: '',
      password: '',
      status: '',
      statusDetails: null,
      showPassword: false
    }
  },
  computed: {
    invalidForm () {
      return this.passwordErrors.all || this.invalidEmail
    },
    invalidEmail () {
      return !this.checkEmailValidity(this.email)
    },
    passwordErrors () {
      /* if(/^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,}$/.test(this.password)) {
        return null
      } */
      let maiuscola = !(/[A-Z]/.test(this.password))
      let minuscola = !(/[a-z]/.test(this.password))
      let simbolo = !(/[!@#$&*.:]/.test(this.password))
      let cifra = !(/[0-9]/.test(this.password))
      let lunghezza = !(/^.{8,}$/.test(this.password))
      return {
        maiuscola, minuscola, simbolo, cifra, lunghezza, all: maiuscola || minuscola || simbolo || cifra || lunghezza
      }
    },
    isWaiting () {
      return this.status === 'waiting'
    }
  },
  methods: {
    register () {
      this.showPassword = false
      this.status = 'waiting'
      this._doUserPreRegistration({
        Email: this.email,
        Password: this.password
      }).then(() => {
        this.status = 'success'
        /* this.internalBus.$emit('notify:success', {
          text: this.dictValue('RegistrationDone'),
          key: this.notifierKey
        }) */
        simpleDialogCreator({
          text: this.dictValue('RegistrationDoSecondStep'),
          okLabel: this.dictValue('Close'),
          faicon: 'fa-envelope-o',
          cancelLabel: null
        }).then(() => {
          this.goTo('/', true, true)
        })
      }).catch(response => {
        this.status = 'error'
        let msg = this.dictValue('error') + (response.status === 418 ? '[VAD]' : '')
        if (response.status === 409) {
          this.statusDetails = 'EmailUnavailable'
          msg = this.dictValue('EmailUnavailable')
        } else {
          if (typeof response.body === 'string') {
            msg = response.body
          } else {
            for (let k in response.body) {
              msg = response.body[k][0]
            }
          }
        }
        this.internalBus.$emit('notify:error', {
          text: msg,
          key: this.notifierKey,
          timeout: 3000
        })
      })
    }
  },
  beforeDestroy () {},
  mounted () {
    /* if (process.env.NODE_ENV === 'development') {
      this.name = 'Vincenzo'
      this.surname = 'Minolfi'
      this.birthdate = '1987-05-27'
      this.birthplace = 'Breno'
      this.email = 's.orioli@nomos.biz'
      this.fiscalCode = 'MNLVCN87E27B149Y'
      this.password = 'Pippo27!'
      this.status = ''
      this.statusDetails = null
      this.showPassword = false
      this.mediaSerialNumber = '564673478567768'
      this.mediaUnicity = '45'
      this.condizioniVendita = true
    } */
  },
  watch: {}
}
</script>

<style>

#password-errors {
  list-style: none;
}

#app.mobile .reg-form > * {
  grid-template-columns: repeat(1, 100%);
}

#app.desktop.small .reg-form > * {
  grid-template-columns: repeat(2, 50%);
}

.reg-form > * {
  display: grid;
  column-gap: .1rem;
  grid-template-columns: repeat(4, 25%);
  padding-top: .1rem;
}

</style>
